import { Alert } from 'antd';

import { interfMessage } from '../interfaces';

import useToastMessage from './useToastMessage';

interface interfProps {
    message: interfMessage,
    onRemoveMessage: (id: number) => void,
}

export default function ToastMessage({ message, onRemoveMessage }: interfProps) {
    const { handleRemoveToast } = useToastMessage(message, onRemoveMessage);

    return (
        <Alert
            message={message.text}
            description={message.description}
            onClose={handleRemoveToast}
            type={message.type}
            showIcon
            closable
            style={{
                marginBottom: '8px',
            }}
        />
    )
}
